
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';
import { WorkUser } from '../models/work-user';

export function getUpdateProfileDtoFormGroup() {
return new FormGroup({
    hasChanges: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    message: new FormControl<string | undefined>('', [Validators.required]),
    user: new FormControl<WorkUser | undefined>(undefined, [Validators.required]),
})
;
}
      